import React from "react";

export const HeartIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "translateX(1px)" }}
      {...props}
    >
      <path
        d="M19.5429 14.1187L11.5751 22.01L3.60736 14.1187C3.08181 13.6073 2.66785 12.9926 2.39153 12.3134C2.11521 11.6341 1.98253 10.905 2.00184 10.172C2.02115 9.43892 2.19203 8.7178 2.50373 8.05404C2.81542 7.39027 3.26117 6.79823 3.81291 6.3152C4.36465 5.83217 5.01043 5.46861 5.70958 5.24741C6.40873 5.02622 7.14611 4.95218 7.87528 5.02997C8.60445 5.10775 9.30962 5.33567 9.94637 5.69937C10.5831 6.06307 11.1377 6.55468 11.5751 7.14323C12.0144 6.55895 12.5696 6.07164 13.206 5.7118C13.8423 5.35196 14.546 5.12733 15.2731 5.05198C16.0003 4.97663 16.7351 5.05217 17.4317 5.27388C18.1283 5.49559 18.7716 5.85869 19.3214 6.34046C19.8712 6.82224 20.3157 7.41231 20.6269 8.07375C20.9382 8.73519 21.1096 9.45375 21.1304 10.1845C21.1512 10.9152 21.0209 11.6423 20.7477 12.3204C20.4746 12.9985 20.0644 13.6129 19.5429 14.1251"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
